export default "__VITE_ASSET__FAHjyrh6__"